(() => {
  function initialize(scope) {
    const carousels = scope.matches?.('[data-scene-carousel]') ? [scope] : scope.querySelectorAll('[data-scene-carousel]');
    carousels.forEach((carousel) => {
    if (carousel.dataset.sceneInitialized === 'true') return;
    const rail = carousel.querySelector('[data-scene-rail]');
    const slides = rail ? [...rail.querySelectorAll('.ks-rebuild__scene')] : [];
    const previous = carousel.querySelector('[data-scene-prev]');
    const next = carousel.querySelector('[data-scene-next]');
    const progress = carousel.querySelector('[data-scene-progress]');
    const controls = carousel.querySelector('[data-scene-controls]');
    const count = carousel.querySelector('[data-scene-count]');
    const status = carousel.querySelector('[data-scene-status]');
    if (!rail || slides.length < 2 || !previous || !next || !progress || !controls || !count || !status) return;
    carousel.dataset.sceneInitialized = 'true';

    const controller = new AbortController();
    const { signal } = controller;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;

    function update() {
      const maximum = Math.max(rail.scrollWidth - rail.clientWidth, 0);
      const position = Math.min(Math.abs(rail.scrollLeft), maximum);
      controls.hidden = maximum < 3;
      previous.disabled = position < 2;
      next.disabled = position >= maximum - 2;
      progress.style.width = `${maximum ? 18 + 82 * position / maximum : 100}%`;

      const viewport = rail.getBoundingClientRect();
      const visible = slides.flatMap((slide, index) => {
        const bounds = slide.getBoundingClientRect();
        return bounds.right > viewport.left + 8 && bounds.left < viewport.right - 8 ? [index + 1] : [];
      });
      if (!visible.length) return;
      const first = visible[0];
      const last = visible[visible.length - 1];
      const concise = first === last ? `${first} of ${slides.length}` : `${first}–${last} of ${slides.length}`;
      if (count.textContent !== concise) count.textContent = concise;
      const spoken = first === last
        ? `Portrait ${first} of ${slides.length} in view`
        : `Portraits ${first} through ${last} of ${slides.length} in view`;
      if (status.textContent !== spoken) status.textContent = spoken;
    }

    function move(direction) {
      const gap = Number.parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      const step = slides[0].getBoundingClientRect().width + gap;
      const rtl = window.getComputedStyle(rail).direction === 'rtl';
      rail.scrollBy({
        left: step * direction * (rtl ? -1 : 1),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    previous.addEventListener('click', () => move(-1), { signal });
    next.addEventListener('click', () => move(1), { signal });
    rail.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const rtl = window.getComputedStyle(rail).direction === 'rtl';
      move(event.key === 'ArrowRight' ? (rtl ? -1 : 1) : (rtl ? 1 : -1));
    }, { signal });
    rail.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => { frame = 0; update(); });
    }, { passive: true, signal });
    window.addEventListener('resize', update, { passive: true, signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(carousel)) return;
      controller.abort();
      if (frame) window.cancelAnimationFrame(frame);
    }, { signal });
    update();
    });
  }

  if (window.__ksRebuildSceneCarouselInit) {
    window.__ksRebuildSceneCarouselInit(document);
    return;
  }
  window.__ksRebuildSceneCarouselInit = initialize;
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
